/* Mobile filter bar — staged selection, ONE navigation. The sheet is a view onto
 * #CollectionFilterForm; apply writes back and hands off to the theme's loadForm(). */
(function () {
  var root = document.querySelector('[data-mfb]');
  if (!root) return;

  var form = document.getElementById('CollectionFilterForm');
  if (!form) return;

  var sheet = root.querySelector('[data-mfb-sheet]');
  var shade = root.querySelector('[data-mfb-shade]');
  var opts = root.querySelector('[data-mfb-opts]');
  var title = root.querySelector('[data-mfb-title]');
  var applyBtn = root.querySelector('[data-mfb-apply]');

  var facet = null;     // param_name, or 'price'
  var facetType = null; // 'list' | 'price'

  function track(name, extra) {
    if (window.posthog) window.posthog.capture(name, extra || {});
  }

  /* Per-value counts (Shopify's value.count) — free, no fetch. */
  var COUNTS = {};
  try {
    var raw = root.querySelector('[data-mfb-counts]');
    if (raw) COUNTS = JSON.parse(raw.textContent);
  } catch (e) { COUNTS = {}; }   // counts are a nicety; never break the sheet over them

  /* Apply stays disabled until the staged selection differs from what's committed. */
  var committed = '';

  function stagedSignature() {
    if (facetType === 'price') {
      var min = opts.querySelector('[data-mfb-price=min]');
      var max = opts.querySelector('[data-mfb-price=max]');
      return (min ? min.value.trim() : '') + '~' + (max ? max.value.trim() : '');
    }
    return Array.prototype.map.call(
      opts.querySelectorAll('.mfb__opt[aria-pressed="true"]'),
      function (o) { return o.dataset.value; }
    ).sort().join('|');
  }

  function syncApplyState() {
    if (applyBtn) applyBtn.disabled = stagedSignature() === committed;
  }

  /* Live result count — re-fetch this section with the staged params. Counting rendered
     cards would be wrong: that's the pagination limit, not the total. */
  var countSeq = 0;
  var countTimer = null;

  function setCount(n) {
    var el = root.querySelector('[data-mfb-apply-count]');
    if (el) el.textContent = n;
  }

  /* Current form state, facet under edit replaced by what's staged. */
  function stagedQuery() {
    var price = priceInputs();
    var pairs = [];

    Array.prototype.forEach.call(form.querySelectorAll('input, select'), function (i) {
      if (!i.name) return;
      if (i.name === facet) return;                                  // staged below
      if (facetType === 'price' && (i === price.min || i === price.max)) return;
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      if (i.value === '') return;
      pairs.push([i.name, i.value]);
    });

    if (facetType === 'price') {
      var min = opts.querySelector('[data-mfb-price=min]');
      var max = opts.querySelector('[data-mfb-price=max]');
      if (price.min && min && min.value.trim()) pairs.push([price.min.name, min.value.trim()]);
      if (price.max && max && max.value.trim()) pairs.push([price.max.name, max.value.trim()]);
    } else {
      Array.prototype.forEach.call(
        opts.querySelectorAll('.mfb__opt[aria-pressed="true"]'),
        function (o) { pairs.push([facet, o.dataset.value]); }
      );
    }

    return pairs.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
    }).join('&');
  }

  function refreshCount() {
    if (!window.fetch) return;                  // count stays at last known value
    var mine = ++countSeq;
    var url = window.location.pathname + '?' + stagedQuery() + '&section_id=collection-template';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (mine !== countSeq) return;          // a newer toggle already fired
        var m = html.match(/data-mfb-count[^>]*>\s*(\d+)\s*</);
        if (m) setCount(m[1]);
      })
      .catch(function () { /* keep the last known count */ });
  }

  function queueCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(refreshCount, 250);
  }

  /* Real inputs for a list facet, from the live form. */
  function inputsFor(param) {
    return Array.prototype.filter.call(
      form.querySelectorAll('input[type=checkbox], input[type=radio]'),
      function (i) { return i.name === param; }
    );
  }

  function priceInputs() {
    return {
      min: form.querySelector('#CCPriceRangeMin'),
      max: form.querySelector('#CCPriceRangeMax')
    };
  }

  /* Radio facets (availability) allow one value — detected by input type, not param name. */
  function isSingleSelect() {
    var first = inputsFor(facet)[0];
    return !!first && first.type === 'radio';
  }

  function renderListOptions() {
    inputsFor(facet).forEach(function (input) {
      /* two markups: list facets vs the availability toggle */
      var label = input.closest('.filter-group__item') || input.closest('.filter-toggle__input-label');
      if (!label) return;

      var textEl = label.querySelector('.filter-group__item__text') ||
                   label.querySelector('.filter-toggle__input-label-text');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mfb__opt';
      b.dataset.value = input.value;
      b.setAttribute('aria-pressed', String(input.checked));
      if (input.disabled) b.disabled = true;

      var swatch = label.querySelector('.filter-group__item__color');
      if (swatch) {
        /* Clone the theme's own swatch unmodified — flat colours and image swatches (twoTone.png) both render as live. */
        var dot = (swatch.parentElement &&
                   swatch.parentElement.classList.contains('swatch-border')
                     ? swatch.parentElement
                     : swatch).cloneNode(true);
        dot.removeAttribute('id');
        b.appendChild(dot);
      }

      b.appendChild(
        document.createTextNode(textEl ? textEl.textContent.trim() : input.value)
      );

      var n = (COUNTS[facet] || {})[input.value];
      if (typeof n === 'number') {
        var c = document.createElement('span');
        c.className = 'mfb__opt-count';
        c.textContent = n;
        b.appendChild(c);
      }

      opts.appendChild(b);
    });
  }

  function renderPriceOptions() {
    var real = priceInputs();
    if (!real.min || !real.max) return;

    var symbol = (document.querySelector('.cc-price-range__input-currency-symbol') || {}).textContent || '$';
    var wrap = document.createElement('div');
    wrap.className = 'mfb__price';
    wrap.innerHTML =
      '<span class="mfb__price-field"><span>' + symbol + '</span>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" data-mfb-price="min" placeholder="' +
      (real.min.getAttribute('placeholder') || '0') + '"></span>' +
      '<span class="mfb__price-sep">to</span>' +
      '<span class="mfb__price-field"><span>' + symbol + '</span>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" data-mfb-price="max" placeholder="' +
      (real.max.getAttribute('placeholder') || '') + '"></span>';

    wrap.querySelector('[data-mfb-price=min]').value = real.min.value || '';
    wrap.querySelector('[data-mfb-price=max]').value = real.max.value || '';
    opts.appendChild(wrap);
  }

  function open(pill) {
    facet = pill.dataset.facet;
    facetType = pill.dataset.type === 'price' ? 'price' : 'list';
    title.textContent = pill.dataset.label;
    opts.innerHTML = '';

    if (facetType === 'price') renderPriceOptions();
    else renderListOptions();

    sheet.hidden = false;
    shade.hidden = false;
    /* lock html too — it may be the scroller, and body alone leaves iOS scrolling */
    document.documentElement.classList.add('mfb-locked');
    document.body.classList.add('mfb-locked');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      shade.classList.add('is-open');
    });
    if (facetType === 'price') {
      Array.prototype.forEach.call(opts.querySelectorAll('[data-mfb-price]'), function (i) {
        i.addEventListener('input', function () { syncApplyState(); queueCount(); });
      });
    }

    committed = stagedSignature();   // baseline: what is already applied
    syncApplyState();
    refreshCount();   // the sheet opens already showing the current result count
    track('mfb_facet_open', { facet: facet });
  }

  function close() {
    sheet.classList.remove('is-open');
    shade.classList.remove('is-open');
    document.documentElement.classList.remove('mfb-locked');
    document.body.classList.remove('mfb-locked');
    setTimeout(function () {
      sheet.hidden = true;
      shade.hidden = true;
    }, 300);
  }

  /* Commit onto the real inputs, then ONE navigation. */
  function commit() {
    var picked = [];

    if (facetType === 'price') {
      var real = priceInputs();
      var min = opts.querySelector('[data-mfb-price=min]');
      var max = opts.querySelector('[data-mfb-price=max]');
      if (real.min && min) { real.min.value = min.value.trim(); if (real.min.value) picked.push('gte:' + real.min.value); }
      if (real.max && max) { real.max.value = max.value.trim(); if (real.max.value) picked.push('lte:' + real.max.value); }
    } else {
      inputsFor(facet).forEach(function (input) {
        var o = opts.querySelector('.mfb__opt[data-value="' + window.CSS.escape(input.value) + '"]');
        if (!o) return;
        input.checked = o.getAttribute('aria-pressed') === 'true';
        if (input.checked) picked.push(input.value);
      });
    }

    track('mfb_apply', { facet: facet, values: picked, count: picked.length });

    var activeSort = document.querySelector('#sort-dropdown-options .link-dropdown__link--active');
    var sortUrl = activeSort ? activeSort.getAttribute('href').split('?').pop() : '';

    /* Theme's own URL builder, so URLs match the control arm exactly. */
    if (typeof window.loadForm === 'function' && window.jQuery) {
      window.loadForm(window.jQuery(form), sortUrl);
    } else {
      form.submit();
    }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mfb-clearall]')) return; // plain link, let it navigate

    var pill = e.target.closest('.mfb__pill:not(.mfb__pill--clear)');
    if (pill) { e.preventDefault(); open(pill); return; }

    if (e.target.closest('[data-mfb-close]') || e.target.closest('[data-mfb-shade]')) {
      close();
      return;
    }

    var opt = e.target.closest('.mfb__opt');
    if (opt && !opt.disabled) {
      var on = opt.getAttribute('aria-pressed') !== 'true';
      if (isSingleSelect()) {
        if (!on) return;   // a radio cannot be un-picked, only replaced
        Array.prototype.forEach.call(opts.querySelectorAll('.mfb__opt'), function (o) {
          o.setAttribute('aria-pressed', 'false');
        });
        on = true;
      }
      opt.setAttribute('aria-pressed', String(on));
      track('mfb_value_toggle', { facet: facet, value: opt.dataset.value, selected: on });
      syncApplyState();
      queueCount();
      return;
    }

    if (e.target.closest('[data-mfb-clear]')) {
      if (facetType === 'price') {
        opts.querySelectorAll('[data-mfb-price]').forEach(function (i) { i.value = ''; });
      } else {
        opts.querySelectorAll('.mfb__opt').forEach(function (o) {
          o.setAttribute('aria-pressed', 'false');
        });
      }
      track('mfb_clear', { facet: facet });
      syncApplyState();
      queueCount();
      return;
    }

    if (e.target.closest('[data-mfb-apply]')) {
      applyBtn.disabled = true; // a second tap must not fire a second navigation
      commit();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });
})();
